import React from 'react';
import { CreditCards } from 'src/components/credit-cards';
import { LearnMoreHowItWorks } from 'src/components/learn-more-how-it-works';
import { TrustBanner } from 'src/components/trust-banner';
import { Button } from 'src/components/v2/button';
import { COUNTRY_BY_CURRENCY_MAP } from 'src/constants/country-by-currency-map';
import { useAppContext } from 'src/context/store/app-provider';
import { useLocale } from 'src/hooks/use-locale';

import { PopupLearnMoreBackgroundHeader } from '../popup-learn-more-background-header';
import styles from './styles.css';

interface Props {
  onClose?: () => void;
  onContinue?: () => void;
}

export const NonStandartLearnMore = ({ onClose, onContinue }: Props) => {
  const { currency, partnerCharges } = useAppContext();
  const t = useLocale();
  const country = COUNTRY_BY_CURRENCY_MAP[currency];

  return (
    <>
      <PopupLearnMoreBackgroundHeader
        onClose={onClose}
        title={t('pay_in_interest_free_payments')}
        subtitle={t('split_your_purchase_and_pay_over_time')}
      />

      <LearnMoreHowItWorks partnerCharges={partnerCharges} />

      {country === 'KSA' ? (
        <TrustBanner
          title={t('shariah_compliant_payments')}
          description={t('our_payment_options_meet_islamic_finance_standards')}
          icon="shariat-modern"
          iconClassName={styles.bannerIcon}
        />
      ) : (
        <TrustBanner
          title={t('tabby_trusted.trusted_by_milions')}
          description={t('over_20_million_shoppers_pay_with_tabby')}
          icon="people"
        />
      )}

      <TrustBanner
        title={t('tabby_care.show_safely')}
        description={t('tabby_care.buyer_protection_included')}
        icon="tabby-care"
      />

      {!!onContinue && (
        <Button onClick={onContinue} testAttr="continue-shopping">
          {t('tabbySplit.continue_shopping')}
        </Button>
      )}

      <CreditCards country={country} fullWidth />
    </>
  );
};
